import { useColorMode, useToken } from "@chakra-ui/react";
import { useLayoutEffect, useState } from "react";
import type { ColorToken } from "../theme/colors/types";

/**
 * useToken("colors", [...]) の型安全なラッパー
 *
 * @example
 * const commonBase = useColorToken("common.base"); // "#FFFFFF"
 */
export function useColorToken(token: ColorToken): string {
  const { colorMode } = useColorMode();
  const value = useToken("colors", [token])[0];
  const [resolved, setResolved] = useState<string>(value ?? "");

  useLayoutEffect(() => {
    if (value?.startsWith("var(")) {
      const varName = value.slice(4, -1);
      setResolved(
        getComputedStyle(document.documentElement)
          .getPropertyValue(varName)
          .trim(),
      );
    } else {
      setResolved(value);
    }
  }, [value, colorMode]);

  return resolved;
}
